export const CATEGORIES = [
  { value: "singole", label: "Carte Singole" },
  { value: "sigillati", label: "Prodotti Sigillati" },
  { value: "accessori", label: "Accessori" },
  { value: "gadget", label: "Gadget e Idee Regalo" },
];
export const CATEGORY_LABEL = Object.fromEntries(CATEGORIES.map((c) => [c.value, c.label]));

export const ACCESSORY_TYPES = [
  { value: "sleeves", label: "Sleeves (bustine protettive)" },
  { value: "binder", label: "Binder e album" },
  { value: "deckbox", label: "Deck box" },
  { value: "toploader", label: "Toploader" },
  { value: "altri", label: "Playmat e altri accessori" },
];
export const ACCESSORY_LABEL = Object.fromEntries(ACCESSORY_TYPES.map((c) => [c.value, c.label]));

export const GAMES = ["Pokémon", "Magic", "Yu-Gi-Oh!", "One Piece", "Lorcana", "Riftbound", "Dragon Ball Super", "Universale"];

export const CONDITIONS = [
  { value: "M", label: "Mint (M)" },
  { value: "NM", label: "Near Mint (NM)" },
  { value: "EX", label: "Excellent (EX)" },
  { value: "GD", label: "Good (GD)" },
  { value: "LP", label: "Light Played (LP)" },
  { value: "PL", label: "Played (PL)" },
  { value: "PO", label: "Poor (PO)" },
];

export const LANGUAGES = ["Italiano", "Inglese", "Giapponese", "Francese", "Tedesco", "Spagnolo", "Portoghese", "Coreano", "Cinese"];

export const RARITIES = ["Secret Rare", "Ultra Rare", "Super Rare", "Rare", "Common"];

export const RARITY_STYLE = {
  "Secret Rare": "foil-border text-black",
  "Ultra Rare": "bg-amber-500 text-black",
  "Super Rare": "bg-violet-500 text-white",
  Rare: "bg-cyan-500 text-black",
  Common: "bg-slate-500 text-white",
};

export const SORTS = [
  { value: "recenti", label: "Più recenti" },
  { value: "prezzo_asc", label: "Prezzo crescente" },
  { value: "prezzo_desc", label: "Prezzo decrescente" },
  { value: "valutazione", label: "Più votati" },
  { value: "nome", label: "Nome A-Z" },
];

export const PAYMENT_METHODS = [
  { value: "card", label: "Carta di credito / debito", desc: "Visa, Mastercard, Amex — pagamento sicuro con Stripe" },
  { value: "paypal", label: "PayPal", desc: "Verrai reindirizzato alla pagina sicura di pagamento PayPal" },
  { value: "bonifico", label: "Bonifico bancario", desc: "Spediamo alla ricezione dell'accredito" },
  { value: "contrassegno", label: "Contrassegno", desc: "Paghi al corriere alla consegna (+3,00 €)" },
];
export const PAYMENT_LABEL = { ...Object.fromEntries(PAYMENT_METHODS.map((p) => [p.value, p.label])), credito: "Credito negozio", negozio: "Pagamento in negozio" };
export const B2B_PAYMENT_METHODS = [
  { value: "bonifico", label: "Bonifico bancario", desc: "Evadiamo l'ordine alla ricezione dell'accredito" },
  { value: "negozio", label: "Pagamento in negozio", desc: "Paghi al ritiro a Ragusa (solo con ritiro in negozio)" },
];
export const VAT_RATE = 22;

export const ORDER_STATUS = {
  in_attesa_pagamento: { label: "In attesa di pagamento", cls: "bg-amber-500/15 text-amber-700 border-amber-500/30" },
  in_attesa_release: { label: "In attesa di release", cls: "bg-violet-500/15 text-violet-500 border-violet-500/30" },
  pagato: { label: "Pagato", cls: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30" },
  in_lavorazione: { label: "In lavorazione", cls: "bg-cyan-500/15 text-cyan-700 border-cyan-500/30" },
  pronto_ritiro: { label: "Pronto per il ritiro", cls: "bg-teal-500/15 text-teal-700 border-teal-500/30" },
  spedito: { label: "Spedito", cls: "bg-violet-500/15 text-violet-500 border-violet-500/30" },
  consegnato: { label: "Consegnato", cls: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30" },
  annullato: { label: "Annullato", cls: "bg-rose-500/15 text-rose-600 border-rose-500/30" },
};

// Dati bancari di esempio: sostituiscili con quelli reali del negozio
export const BANK_INFO = {
  holder: "Card Source",
  iban: "IT60 X054 2811 1010 0000 0123 456",
  bank: "Banca di Esempio",
};

export const EU_COUNTRIES = ["Italia", "Austria", "Belgio", "Bulgaria", "Cipro", "Croazia", "Danimarca", "Estonia", "Finlandia", "Francia", "Germania", "Grecia", "Irlanda", "Lettonia", "Lituania", "Lussemburgo", "Malta", "Paesi Bassi", "Polonia", "Portogallo", "Repubblica Ceca", "Romania", "Slovacchia", "Slovenia", "Spagna", "Svezia", "Ungheria"];

export const FINISHES = ["Foil", "Non-Foil"];

export const CONDITION_FACTOR = { NM: 1, EX: 0.9, GD: 0.75, LP: 0.65, PL: 0.5 };
export const CASH_FACTOR = 0.3;

export const BUYLIST_STATUS = {
  in_revisione: { label: "In revisione", cls: "bg-amber-500/15 text-amber-700 border-amber-500/30" },
  approvata: { label: "Approvata – portala in negozio", cls: "bg-cyan-500/15 text-cyan-700 border-cyan-500/30" },
  rifiutata: { label: "Rifiutata", cls: "bg-rose-500/15 text-rose-600 border-rose-500/30" },
  completata: { label: "Completata", cls: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30" },
};

export const EVENT_GAMES = ["Magic", "Pokémon", "One Piece", "Yu-Gi-Oh!", "Lorcana", "Riftbound", "Dragon Ball Super", "Altro"];

export const ANNOUNCEMENT = "Spedizione gratuita in Italia sopra i €200 d'ordine e in Europa sopra i €500";

export const FAQ = [
  ["Quali giochi trattate?", "Magic: The Gathering, Pokémon, Yu-Gi-Oh!, One Piece, Lorcana, Riftbound e Dragon Ball Super: carte singole, prodotti sigillati e accessori."],
  ["Come funziona la vendita delle mie carte?", "Porta in negozio carte singole, prodotti sigillati o accessori: il nostro staff li valuta di persona e ti fa una proposta. Puoi ricevere il 100% della proposta come credito negozio (accreditato sul tuo account) oppure il 30% della proposta in contanti."],
  ["Come si usa il credito negozio?", "Il credito ottenuto dalle valutazioni in negozio appare nel tuo account e puoi usarlo al checkout su qualsiasi ordine, anche in combinazione con altri metodi di pagamento."],
  ["Posso ritirare l'ordine in negozio?", "Sì, al checkout scegli “Ritiro in negozio”: nessun costo di spedizione. Ti avvisiamo quando l'ordine è pronto."],
  ["Quanto costa la spedizione?", "Italia: 6,30 €, gratuita sopra i 200 € d'ordine. Europa (UE): 19,30 €, gratuita sopra i 500 €. Le carte singole sono spedite in sleeve + toploader."],
  ["Cosa significano NM, EX, GD, LP e PL?", "Sono i gradi di condizione: Near Mint (praticamente perfetta), Excellent (lievissimi segni), Good (usura visibile ma buona), Light Played (bordi o superficie segnati) e Played (usura evidente)."],
  ["Le iscrizioni agli eventi sono rimborsabili?", "L'iscrizione online è gratuita e riserva il posto: la quota si paga in negozio il giorno dell'evento. Se non puoi partecipare, annulla l'iscrizione per liberare il posto."],
  ["Cos'è il pre-grading?", "Valutiamo le condizioni delle tue carte prima di inviarle a un servizio di grading professionale (PSA, BGS, CGC), così sai in anticipo se conviene."],
];

export const GAME_PAGES = [
  { slug: "magic", name: "Magic", title: "Magic: The Gathering", logo: "/brand/games/magic.png", text: "Il gioco di carte collezionabili originale: buste, box, Commander e carte singole." },
  { slug: "pokemon", name: "Pokémon", title: "Pokémon TCG", logo: "/brand/games/pokemon.png", text: "Elite Trainer Box, buste, collezioni speciali e carte singole Pokémon." },
  { slug: "one-piece", name: "One Piece", title: "One Piece Card Game", logo: "/brand/games/one-piece.png", text: "Booster box, starter deck e carte singole del One Piece Card Game." },
  { slug: "yu-gi-oh", name: "Yu-Gi-Oh!", title: "Yu-Gi-Oh! Trading Card Game", logo: "/brand/games/yu-gi-oh.png", text: "Buste, structure deck e carte singole Yu-Gi-Oh!." },
  { slug: "riftbound", name: "Riftbound", title: "Riftbound: League of Legends TCG", logo: "/brand/games/riftbound.png", text: "Il nuovo TCG di League of Legends: box, buste e carte singole." },
  { slug: "lorcana", name: "Lorcana", title: "Disney Lorcana", logo: "/brand/games/lorcana.png", text: "Il TCG Disney: booster, starter deck, gift set e carte singole." },
  { slug: "dragon-ball-super", name: "Dragon Ball Super", title: "Dragon Ball Super Card Game", logo: "/brand/games/dragon-ball-super.png", text: "Fusion World e Masters: box, buste e carte singole." },
];

export const SOCIALS = [
  { name: "Instagram", url: "https://www.instagram.com/cardsource.eu", handle: "@cardsource.eu" },
  { name: "Facebook", url: "https://www.facebook.com/cardsource.eu", handle: "Card Source" },
  { name: "TikTok", url: "https://www.tiktok.com/@cardsource.eu", handle: "@cardsource.eu" },
  { name: "YouTube", url: "https://www.youtube.com/@cardsource", handle: "Card Source" },
];

export const SICILY_PROVINCES = ["AG", "CL", "CT", "EN", "ME", "PA", "RG", "SR", "TP"];
export const COMPANY = { name: "Card Source S.R.L.", vat: "01900060888", address: "Viale dei Platani 37/A, 97100 Ragusa (RG)" };
export const fmtDate = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });
